import './App.css';
import{BrowserRouter, Routes, Route, Link } from 'react-router-dom'
import React from 'react';
import Index from './HomeComponent/Index';
import LenderIndex from './LenderComponents/LenderIndex';
import DealerIndex from './DealerComponents/DealerIndex';
import AboutIndex from './AboutUsComponents/AboutIndex';
import OemIndex from './OEMComponents/OemIndex';
import HeaderComponent from './CommonComponent/HeaderComponent';
import FooterComponent from './CommonComponent/FooterComponent';
import CarrerComponent from './CommonComponent/CarrerComponent';
import ContactComponant from './CommonComponent/ContactComponant';
import TeamComponent from './CommonComponent/TeamComponent';
import ChoiceDLA from './DLAComponents/ChoiceDLA';

function App() {
	
	return (
		<>
			<BrowserRouter>
				{/* Header Section */}
				<HeaderComponent />
				<Routes>
					<Route path='/' exact element={<Index />} />
					<Route path='/lender' element={<LenderIndex />} />
					<Route path='/dealer' element={<DealerIndex />} />
					<Route path='/about' element={<AboutIndex />} />
					<Route path='/oem' element={<OemIndex />} />
					<Route path='/how-it-works' element ={<Index />} />
					<Route path='/career' element={<CarrerComponent />} />
					<Route path='/contact' element={<ContactComponant />} />
					<Route path='/team' element={<TeamComponent />} />
					<Route path='/choice-dla' element={<ChoiceDLA />} />
				</Routes>
				
				
				{/* Footer Section */}
				<FooterComponent />
			</BrowserRouter>
			
			
		</>
    );
}

export default App;
